import styled from 'styled-components'

export const CheckedIcon = styled.div`
  color: ${({theme}) => theme.blue};
  margin-left: auto;
`

export const CheckedP = styled.p`
  color: ${({theme}) => theme.blue};
  margin: 0;
`
